import React, { useState, useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../BaseUrl";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import "./VerifyEmail.css";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [status, setStatus] = useState("verifying"); // 'verifying' | 'success' | 'error' | 'expired'
  const [message, setMessage] = useState("");
  const [resending, setResending] = useState(false);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid or missing verification link.");
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await axios.get(`${BaseUrl}/api/v1/auth/verify-email?token=${token}`);
        if (res.data.success) {
          setStatus("success");
          setMessage("Your email has been verified!");
        }
      } catch (err) {
        const errorMsg = err.response?.data?.message || "Verification failed.";
        setStatus("expired");
        setMessage(errorMsg);
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handleResend = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    setResending(true);
    try {
      await axios.post(
        `${BaseUrl}/api/v1/auth/resend-verification`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage("A new verification email has been sent! Check your inbox.");
      setStatus("error");
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to resend. Please try again later.");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="Login_backgorund">
      <div className="verify-email-card">
        {status === "verifying" && (
          <div className="verify-loading">
            <div className="verify-spinner"></div>
            <h2>Verifying your email...</h2>
            <p>Just a moment while we confirm your email address.</p>
          </div>
        )}

        {status === "success" && (
          <div className="verify-result verify-success">
            <div className="verify-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h2>Email Verified!</h2>
            <p>Welcome to Move n Muse. You're all set.</p>
            <button
              className="verify-btn"
              onClick={() => navigate(user ? "/profile" : "/login")}
            >
              {user ? "Go to Profile" : "Log In"}
            </button>
          </div>
        )}

        {(status === "error" || status === "expired") && (
          <div className="verify-result verify-error">
            <div className="verify-icon verify-icon--error">
              <i className="bi bi-exclamation-circle-fill"></i>
            </div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            {user && (
              <button
                className="verify-btn"
                onClick={handleResend}
                disabled={resending}
              >
                {resending ? "Sending..." : "Resend Verification Email"}
              </button>
            )}
            {!user && (
              <button
                className="verify-btn"
                onClick={() => navigate("/login")}
              >
                Log in to resend
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
